import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Demos.css';

export default function DemoInmobiliaria() {
    return (
        <div className="portfolio-container">
            <Helmet>
                <title>Demo Agente IA Inmobiliario 24/7 | Navi</title>
                <meta name="description"
                      content="Experimenta el potencial de nuestro Agente IA especializado en captar leads y cerrar ventas para el sector inmobiliario."/>
            </Helmet>

            {/* --- ENCABEZADO --- */}
            <header className="portfolio-header" style={{textAlign: 'center'}}>
                <span className="portfolio-category">SECTOR INMOBILIARIO</span>
                <h1 className="portfolio-title">El Agente IA 24/7 de Navitechlabs</h1>
                <h2 className="portfolio-subtitle">
                    La solución tecnológica que está transformando el sector. Capta leads y cierra ventas sin descanso,
                    tanto de día como de noche.
                </h2>
            </header>

            <div className="portfolio-image-wrapper"
                 style={{display: 'flex', gap: '20px', flexDirection: 'column', marginTop: '50px'}}>
                <img src="/imagenes_demos/Demo1_asset2.png" alt="Interfaz del Agente IA Inmobiliario"/>
            </div>
            <div className="portfolio-content">
                <p style={{textAlign: 'center', fontSize: '1.2rem', marginBottom: '40px'}}>
                    Nuestra misión es potenciar tu inmobiliaria mediante inteligencia artificial especializada. Para que
                    experimentes este potencial de primera mano, hemos habilitado una Demo interactiva de nuestro
                    agente.
                </p>

                {/* --- BOTÓN PRINCIPAL A LA DEMO EXTERNA --- */}
                <div style={{textAlign: 'center', margin: '40px 0'}}>
                    <button
                        className="cta-button"
                        style={{fontSize: '1.3rem', padding: '20px 40px', backgroundColor: '#001286', color: '#ffffff'}}
                        onClick={() => window.open('https://demos-demoinmoweb.qrjwoc.easypanel.host/#', '_blank')}
                    >
                        ¡ACCESO A TU DEMO 24/7!
                    </button>
                </div>

                {/* --- LISTA DE BENEFICIOS --- */}
                <h3>Lo que tu Inmobiliaria ganará hoy:</h3>
                <ul>
                    <li><strong>Disponibilidad Absoluta:</strong> Un sistema diseñado para no perder ni una sola
                        oportunidad de negocio, operando 24/7 ininterrumpidamente.
                    </li>
                    <li><strong>Captación de Leads Automatizada:</strong> Nuestro agente IA identifica, cualifica y
                        captura potenciales clientes de forma autónoma, sin intervención humana.
                    </li>
                    <li><strong>Manejo de Alto Tráfico de Preguntas:</strong> Responde simultáneamente a cientos de
                        consultas al instante, sin tiempos de espera ni pérdida de oportunidades.
                    </li>
                    <li><strong>Gestión Integral de Clientes:</strong> Acompaña al cliente durante todo el proceso,
                        desde el primer contacto hasta el cierre, ofreciendo una experiencia personalizada y
                        profesional.
                    </li>
                    <li><strong>Agente Multilingüe:</strong> Soporte en múltiples idiomas, permitiendo atender a
                        clientes de distintas nacionalidades sin barreras comunicativas.
                    </li>
                </ul>

                {/* --- SECCIÓN DE IMÁGENES --- */}
                <div className="portfolio-image-wrapper"
                     style={{display: 'flex', gap: '20px', flexDirection: 'column', marginTop: '50px'}}>
                    <img src="/imagenes_demos/Demo1_asset1.png" alt="Gestión de leads y analíticas"/>
                </div>

                {/* --- CTA FINAL (WHATSAPP) --- */}
                <div className="portfolio-cta-box">
                    <h3>Contáctanos para una Demo Personalizada para tu Negocio</h3>
                    <p>¿Quieres ver cómo el Agente IA puede adaptarse a las necesidades específicas de tu inmobiliaria?
                        Escríbenos y te preparamos una demo a medida, sin compromiso.</p>

                    <button
                        className="cta-button"
                        onClick={() => window.open(
                            'https://wa.me/34624118531?text=%C2%A1Hola!%20He%20visto%20la%20demo%20inmobiliaria%20y%20me%20gustar%C3%ADa%20solicitar%20una%20visita%20personal%20de%20validaci%C3%B3n%20para%20mi%20negocio.',
                            '_blank'
                        )}
                    >
                        Solicitar Demo a Medida
                    </button>
                </div>
            </div>
        </div>
    );
}